function validateNumericAndCommas(int) {
    var re = /^[0-9,]*$/;
    return re.test(int);
}
export default validateNumericAndCommas;
